import type { SVGProps } from 'react';

export function CheckCircleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.3333 9.23333V10C18.3323 11.797 17.7504 13.5456 16.6744 14.9849C15.5985 16.4241 14.0861 17.4771 12.3628 17.9866C10.6395 18.4961 8.79771 18.4349 7.11205 17.8122C5.42639 17.1894 3.98721 16.0384 3.00912 14.5309C2.03103 13.0234 1.56648 11.2401 1.68472 9.44693C1.80296 7.6538 2.49766 5.94694 3.66522 4.58089C4.83278 3.21485 6.41064 2.26282 8.16348 1.86679C9.91632 1.47076 11.7502 1.65195 13.3917 2.38333"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 3.33333L10 11.675L7.5 9.175"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
